import { styled } from '@mui/material/styles';
import { ModalBase } from '@components/Modal';

export const SplitModal = styled(ModalBase)({
    '& .modal-base-paper': {
        outline: 'none',
        width: 'calc(100% - 32px)',
        height: 'calc(var(--100vh) - 32px)',
    },
    '& .modal-base-content': {
        display: 'grid',
        gridTemplateColumns: '50% 50%',
        '@media (max-width: 768px)': {
            gridTemplateColumns: '100%',
        },
    },
});

export const PreviewWrapper = styled('div')({
    backgroundColor: '#f2f2f2',
    overflowY: 'auto',
    padding: '24px 0',
    '@media (max-width: 768px)': {
        overflowY: 'initial',
    },
    '@media (max-width: 420px)': {
        padding: '24px 16px',
    },
});
